import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

export const StyledModal = styled.div`
  background-color: ${props => props.theme.colors.light};
  display: flex;
  height: 100%;
  left: 0;
  overflow: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  ${props =>
    !props.tabletSize &&
    mediaqueries.greaterThan('desktop')`
    background-color: rgba(0, 0, 0, 0.9);
    top: 0;
  `};
`;

export const StyledModalTransparent = styled.div`
  /* display: flex;
  height: 100%;
  width: 100%;
  left: 0;
  overflow: auto;
  position: fixed;
  top: 0;
  z-index: 100; */
  z-index: 100;
  ${mediaqueries.greaterThan('1480px')`
    display: flex;
    height: 100px;
    width: 200px;
    z-index: 100;
    overflow: ${props => props.searchModal === true && 'inherit'};
    position: fixed;
    z-index: 100;
    height: 100%;
    width: 100%;
  `};
  ${mediaqueries.lessThan('1480px')`
    background-color: rgba(0, 0, 0, 0.9);
    top: 0;
    margin: 0;
    display: flex;
    height: 100%;
    left: 0;
    overflow: ${props => props.searchModal === true && 'inherit'};
    position: fixed;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 30%;
  `};
`;

export const StyledModalContent = styled.div`
  margin: auto;
  padding: 0 ${rem('15px')} ${rem('10px')} ${rem('15px')};
  ${mediaqueries.greaterThan('mobile')`
    margin: ${props =>
      props.center !== true && (props.searchModal && '0 auto auto')};
    display: ${props => props.center !== true && (props.searchModal && 'flex')};
    min-width: ${rem('660px')};
    padding: ${props =>
      props.sendEmailsToGroup || props.center === true || props.searchModal
        ? `${rem('150px')} ${rem('75px')} ${rem('0px')} 10rem`
        : `${rem('150px')} ${rem('85px')} ${rem('10px')} ${rem('85px')}`}
  `};
  ${props =>
    !props.tabletSize &&
    mediaqueries.greaterThan('desktop')`
    margin: ${props => props.center === true && 'inherit'}
    background-color: ${props => props.theme.colors.light};
    width: ${props => (props.searchModal === true ? '90%' : '100%')};
    background-color: #ffffff;
    width: 90%;
    display: ${props => (props.searchModal === true ? 'flex' : 'block')};
    top: ${props =>
      props.searchModal === true ||
      props.center === true ||
      (props.sendEmailsToGroup === true && '0')};
    max-width: ${props => props.isMaxWidth === true && '5.875rem'};
    max-height: ${props => props.isMaxHeight && '80vh'};
    overflow: hidden;
    padding:  ${props =>
      props.sendEmailsToGroup === false || props.center === true
        ? '3.125rem 5.2rem'
        : '3.125rem 4.2rem'};
    position: relative;
  `};
`;

export const StyledIconClose = styled(Icon)`
  height: ${rem('19px')};
  position: absolute;
  right: ${rem('32px')};
  top: ${rem('33px')};
  width: ${rem('19px')};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('14px')};
    right: ${rem('21px')};
    top: ${rem('21px')};
    width: ${rem('14px')};
  `};
`;

export const StyledTitle = styled.h2`
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${rem('16px')};
  margin: ${rem('35px')} 0 ${rem('18px')} 0;
  padding: 0 ${rem('26px')};
  text-transform: uppercase;
  ${mediaqueries.greaterThan('mobile')`
    padding: 0;
    text-align: center;   
    margin-top: 0;
  `};
`;
